import Auth from "./Auth";

document.addEventListener("DOMContentLoaded", function () {
	var element = document.getElementById("wp-vino-auth");
	if (typeof element !== "undefined" && element !== null) {
		ReactDOM.render(<Auth />, element);
	}
});
